import React, { useCallback, useEffect, useState } from "react";
import { Content } from "../../components/Containers";
import List from "../../components/List";
import { useModal } from "../../context/ModalContext";
import { createStyle, deleteStyle, getStyle, searchStyle, updateStyle } from "../../api/Style";
import StyleCard from "./StyleCard";
import EditStyle from "./Edit";


export default function Styles() {
  const { showModal } = useModal();
  const [query, setQuery] = useState("");
  const [all, setAll] = useState(false);
  const [page, setPage] = useState(0);
  const [data, setData] = useState({ content: [] });
  const [selected, setSelected] = useState();

  const load = useCallback(() => {
    const search = async () => setData(await searchStyle(query, all, page));
    search();
  }, [query, all, page]);

  useEffect(() => {
    load();
  }, [query, all, page, load]);

  return (
    <>
      <Content>
        <List
          data={data}
          query={query}
          updateQuery={setQuery}
          status={all}
          updateStatus={setAll}
          statusList={[
            { label: "Todos", value: true },
            { label: "Ativos", value: false },
          ]}
          updatePage={setPage}
          onNew={() =>
            setSelected({
              nameBr: "",
            })
          }
          Item={(item) => (
            <StyleCard
              key={"ku" + item.id}
              style={item}
              onEdit={async () => {
                const loaded = await getStyle(item);
                setSelected(loaded);
              }}
              onDelete={async () => {
                try {
                  await deleteStyle(item);
                  load();
                } catch (e) {
                  showModal("O estilo não pode ser apagado", "warn", 10);
                }
              }}
            />
          )}
        />
      </Content>
      <EditStyle
        selected={selected}
        onClose={() => setSelected(null)}
        onSave={async (style) => {
          try {
            if (!!style.id) {
              await updateStyle(style);
            } else {
              await createStyle(style);
            }
            setSelected(null);
            load();
          } catch (e) {
            showModal("Falha ao gravar estilo", "error", 10);
          }
        }}
      />
    </>
  );
}
